__webpack_require__.p = "https://cdn-stg-th.buymed.tech/_next/";